export default __webpack_public_path__ + "static/O0004-371e48f539436c35ea934e7fe90aa099.png";